import React from "react";
import "./Dpu_Mca_Feature.css";

const Dpu_Mca_Feature = () => {
  return (
    <section className="Dpu_Mca_Feature">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="highlight-box">
              <h5 className="text-center text-white mb-0 common_white_text_h5">
                <strong>Admission Open</strong>
                <br />
                <span className="common_white_text_span">
                  July Batch 2026
                </span>
              </h5>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="highlight-box1">
              <h5 className="text-center text-white mb-0 common_white_text_h5">
                <strong>Approved by</strong>
                <br />
                <span className="common_white_text_span">AICTE + UGC </span>
              </h5>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="highlight-box2">
              <h5 className="text-center text-white mb-0 common_white_text_h5">
                <strong>Eligibility</strong>
                <br />
                <span className="common_white_text_span">
                  Any Graduate with 50% Marks
                  <br />
                  (Maths in 10+2){" "}
                </span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dpu_Mca_Feature;
